export const CHAPTER = "chapter";
export const EXTERNAL_CALLBACK = "externalCallback";
export const LINK = "link";
export const NONE = "none";
